import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from 'react-router-dom';
import {Store} from './store/Store';
import {Provider} from 'react-redux'
import 'fabric-history';
import {TourProvider} from '@reactour/tour';
import Button from '@mui/joy/Button';
import './index.css'
import MessageReceiver from './MessageReceiver'
import {steps} from "./utils/utilityComponents/StepContent";

const root = ReactDOM.createRoot(document.getElementById('root'));

const AppWithTour = () => {

    return (
        <TourProvider steps={steps}
                      showBadge={false}
                      badgeContent={({totalSteps, currentStep}) => currentStep + 1 + " of " + totalSteps}
                      prevButton={({setIsOpen}) => {
                          return (
                              <Button variant="soft" size='sm' sx={{
                                  paddingBottom: '4px',
                                  borderRadius: 40,
                                  width: 'clamp(min(100%, 90px), 50%, min(100%, 80px))'
                              }}
                                      onClick={() => {
                                          setIsOpen(false)
                                      }}
                              >
                                  Skip Tour
                              </Button>
                          )
                      }}
                      nextButton={({currentStep, stepsLength, setIsOpen, setCurrentStep, steps,}) => {
                          const last = currentStep === stepsLength - 1
                          return (
                              <Button variant="solid" color="warning" size='sm' sx={{
                                  paddingBottom: '4px',
                                  borderRadius: 40,
                                  width: 'clamp(min(100%, 70px), 50%, min(100%, 70px))'
                              }}
                                      onClick={() => {
                                          if (last) {
                                              setIsOpen(false)
                                          } else {
                                              setCurrentStep((s) => (s === steps?.length - 1 ? 0 : s + 1))
                                          }
                                      }}
                              >
                                  {last ? 'Done!' : 'Next'}
                              </Button>
                          )
                      }}
                      styles={{
                          popover: (base) => ({
                              ...base,
                              borderRadius: 10,
                              left: 20
                          }),
                          maskArea: (base) => ({...base, rx: 5}),
                          controls: (base) => ({
                              ...base,
                              marginTop: 20,
                              marginBottom: 20,
                              justifyContent: 'space-around'
                          }),
                      }}>
            <BrowserRouter>
                <Provider store={Store}>
                    <MessageReceiver>
                        <App/>
                    </MessageReceiver>
                </Provider>
            </BrowserRouter>
        </TourProvider>
    );
};
root.render(<AppWithTour/>);

reportWebVitals();
